var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Typography, useMediaQuery, } from '@mui/material';
import { useAppContext } from '../context/AppContext';
import theme from '../Theming/DefaultTheme';
import { useForm } from 'react-hook-form';
import Grid from '@mui/material/Grid2';
import CodeInput from '../components/inputs/CodeInput';
import PageWrapper from '../components/wrappers/PageWrapper';
var loginFormContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    gap: 16,
    margin: '50px 16px',
};
var panelImage = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};
var logoContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    margin: 16,
    padding: 0,
};
var loadingIndicatorContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    margin: 0,
    padding: 0,
};
var AuthPage = function () {
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var _a = useAppContext(), startSession = _a.startSession, joinSession = _a.joinSession, loading = _a.loading;
    var _b = useForm(), handleSubmit = _b.handleSubmit, setValue = _b.setValue;
    var onSubmit = function (data) {
        joinSession(data.sessionCode);
    };
    var pageContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: isMobile ? '100vh' : '100%',
        background: 'linear-gradient(to top left, #673AB7 8%, #311B92 64%)',
        marginTop: isMobile ? 0 : 20,
    };
    var authPageForm = (_jsx("form", { noValidate: true, onSubmit: handleSubmit(onSubmit), children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, lg: 12 }, children: _jsx(CodeInput, { codeLength: 5, onComplete: function (sessionCode) {
                            setValue('sessionCode', sessionCode);
                        } }) }), _jsx(Grid, { size: { xs: 12, lg: 12 }, style: {
                        display: 'flex',
                        justifyContent: 'center',
                    }, children: _jsx(Button, { type: 'submit', variant: 'contained', disabled: false, style: {
                            textTransform: 'none',
                            backgroundColor: '#1976d2',
                            color: theme.palette.common.white,
                        }, children: "Submit Code" }) })] }) }));
    var handleStartSessionClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            startSession();
            return [2 /*return*/];
        });
    }); };
    return (_jsx(PageWrapper, { children: _jsxs(Grid, { container: true, style: pageContainerStyle, spacing: 2, children: [!isMobile && (_jsx(Grid, { size: { lg: 6, sm: 12 }, children: _jsx(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100vh',
                            margin: 0,
                            padding: 0,
                        }, children: _jsx("img", { src: 'https://strsharedeus.blob.core.windows.net/apps/huddlemaps/images/map-screenshot.png', alt: 'Logo', style: panelImage }) }) })), _jsxs(Grid, { size: { lg: 6, sm: 12 }, children: [_jsxs(Box, { style: loginFormContainer, children: [_jsxs(Box, { style: logoContainer, children: [_jsx("img", { src: 'https://strsharedeus.blob.core.windows.net/apps/huddlemaps/images/icon-marker-white.png', alt: 'Logo', style: { width: 80, height: 'auto' } }), _jsx(Typography, { variant: 'h1', style: { color: theme.palette.common.white }, children: "Huddle Maps" })] }), _jsx(Button, { type: 'submit', variant: 'contained', color: 'primary', disabled: false, onClick: handleStartSessionClick, style: {
                                        textTransform: 'none',
                                        backgroundColor: theme.palette.tertiary.dark,
                                        marginBottom: 16,
                                    }, children: "Start new session" }), _jsx(Typography, { variant: 'h4', style: { color: theme.palette.common.white }, children: "Or Join Session" }), authPageForm] }), _jsx(Box, { style: loadingIndicatorContainer, children: loading && (_jsx(CircularProgress, { style: { color: theme.palette.common.white } })) })] })] }) }));
};
export default AuthPage;
